<template>
  <div id="createGamepass">
    <div class="thead">Создание gamepass</div>

    <pre class="wa">1) Перейдите по <a :href="gameUrl" target="_blank">этой ссылке</a> и создайте Game Pass
2) Нажмите «CREATE A PASS» и заполните форму
3) Выберете созданный gamepass
4) Во вкладке «Details» выберете «Sales» и включите опцию «Item for Sale»
5) Измените цену на желаемую и сохраните изменения
</pre>
  <iframe width="560" height="315" src="https://www.youtube.com/embed/8iBuZ2B31oc?start=122" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
  <button class="wa fs24" @click="find">Выполнил</button>
  <button class="wa fs24 red" @click="goBack">Назад</button>
  </div>
</template>

<script>
import { GetGamepassesRequest } from "@/protos/user_pb.js";
import Utils from "@/utils.js"

export default {
  props: ["data"],

  computed: {
	change() {
	  return this.data.amount ? Utils.recommision(this.data.amount) : null
	},
	gameUrl() {
	  return `https://create.roblox.com/dashboard/creations/experiences/${this.data.universe}/associated-items?activeTab=Pass`
	}
  },

  methods: {
	goBack() {
	  this.$root.setState({ label: 'buy-one', data: this.data })
	},

	find() {
	  const r = new GetGamepassesRequest()
	  r.setGame(this.data.game)
	  this.$root.client.getGamepasses(r, null, (err, resp) => {
		for (const gp of resp.getGamepassesList()) {
		  const pass = {
			id: gp.getId(),
			name: gp.getName(),
			price: gp.getPrice()
		  }

		  if (!this.data.amount || Utils.closeEnough(this.change, pass.price)) {
			const url = `https://web.roblox.com/game-pass/${pass.id}/`
			return this.$root.setState({ label: "buy-one", data: { ...this.data, gamepass: url } })
		  }
		}

		this.$root.toast.error("Не удается найти gamepass, проверьте цену.")
	  })
	},

    copyAmount() {
      navigator.clipboard.writeText(this.change)
    }
  }
}
</script>

<style scoped lang="scss">
#createGamepass > pre {
  line-height: 40px;
} 
</style>
